import "./index.less"
import "./indexMobile.less"
import clamp from 'clamp-js';
import {useEffect, useRef, useState} from "react";
import {motion} from 'framer-motion';
import {isMobile} from "react-device-detect";

export default ({
                    date,
                    title,
                    desc,
                    imageUrl,
                    hasDragged,
                    buttonText,
                    styleData,
                    contentStyle,
                    cardClassName,
                    contentClassName,
                    dateStyle,
                    titleStyle,
                    descStyle,
                }) => {
    const descRef = useRef();

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const backgroundImage = isHovered
        ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 1) 100%),url(${imageUrl})`
        : `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.65) 100%),url(${imageUrl})`;

    const gradientOpacityStates = {
        hovered: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 1) 100%),url(${imageUrl})`,
        notHovered: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.65) 100%),url(${imageUrl})`
    };

    useEffect(() => {
        clamp(descRef.current, {clamp: 2});
    }, [desc]);

    const handleClick = (e) => {
        if (hasDragged) {
            return;
        }

        alert("数据 ->" + contentClassName)
    };

    return <>
        {!isMobile && <motion.div
            className={`card ${isHovered ? 'card-hover' : ''} ${cardClassName}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                ...styleData,
            }}
            initial={{backgroundImage: gradientOpacityStates.notHovered}}
            animate={{backgroundImage: isHovered ? gradientOpacityStates.hovered : gradientOpacityStates.notHovered}}
            transition={{duration: 0.3}}
        >
            <div className={`content ${contentClassName}`} style={{...contentStyle}}>
                <div className={"date"} style={dateStyle}>
                    {date}
                </div>
                <div className={"title"} style={titleStyle}>
                    {title}
                </div>
                <div className={"desc"} ref={descRef} style={descStyle}>
                    {desc}
                </div>
                {buttonText ? <div className={"detailButton"}>
                    {buttonText}
                    <span style={{marginLeft: "6px"}}>
                    <svg width="36" height="12" viewBox="0 0 36 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 1.25H35.5C32 1.58333 25 4.15 25 11.75" stroke="#E35113" stroke-width="2"/>
                    </svg>
                </span>
                </div> : null}
            </div>
        </motion.div>}

        {isMobile && <motion.div
            className={`card-mobile ${isHovered ? 'card-hover' : ''} ${cardClassName}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                ...styleData,
            }}
            initial={{backgroundImage: gradientOpacityStates.notHovered}}
            animate={{backgroundImage: isHovered ? gradientOpacityStates.hovered : gradientOpacityStates.notHovered}}
            transition={{duration: 0.3}}
        >
            <div className={`content-mobile ${contentClassName}`} style={{...contentStyle}}>
                <div className={"date-mobile"} style={dateStyle}>
                    {date}
                </div>
                <div className={"title-mobile"} style={titleStyle}>
                    {title}
                </div>
                <div className={"desc-mobile"} ref={descRef} style={descStyle}>
                    {desc}
                </div>
                {buttonText ? <div className={"detailButton-mobile"}>
                    {buttonText}
                    <span style={{marginLeft: "6px"}}>
                    <svg width="36" height="12" viewBox="0 0 36 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 1.25H35.5C32 1.58333 25 4.15 25 11.75" stroke="#E35113" stroke-width="2"/>
                    </svg>
                </span>
                </div> : null}
            </div>
        </motion.div>}
    </>
}
